import React from 'react';

export default ( { className, fill, ...props } ) => (
    <svg width="24" height="24" className={ className } { ...props } viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M15 6H18C18.55 6 19 6.45 19 7V21C19 21.55 18.55 22 18 22H6C5.45 22 5 21.55 5 21V9C5 8.45 5.45 8 6 8H9V3C9 2.45 9.45 2 10 2H14C14.55 2 15 2.45 15 3V6ZM13 4H11V20H13V4ZM15 8V20H17V8H15ZM9 10V20H7V10H9Z" fill={ fill || 'currentColor' } />
    </svg>
);
